const LoginAction = {
  Log: {
    In: '[Login Action] Log into the system',
    Out: '[Login Action] Log out of the system',
  },
};

export default LoginAction;
